var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":require("../../assets/images/ic_doc.svg"),"alt":""}})])}]

export { render, staticRenderFns }